(function () {
  'use strict';

  var MAX_OUTFITS = 3;
  var requestGeneration = 0;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeImageUrl(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    try {
      var url = new URL(raw, window.location.href);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
    } catch (error) {
      return '';
    }
  }

  function activeWardrobe() {
    if (!window.PrewornWardrobe || typeof window.PrewornWardrobe.getWardrobe !== 'function') return null;
    if (typeof window.PrewornWardrobe.isActive === 'function' && !window.PrewornWardrobe.isActive()) return null;
    var wardrobe = window.PrewornWardrobe.getWardrobe();
    return wardrobe && Number(wardrobe.id || 0) ? wardrobe : null;
  }

  function cleanName(value, fallback) {
    var name = String(value || '').replace(/\s+/g, ' ').trim();
    return name || fallback || 'My Wardrobe';
  }

  function outfitTimestamp(outfit) {
    var fields = ['updatedAt', 'updated_at', 'createdAt', 'created_at', 'savedAt', 'saved_at'];
    for (var index = 0; index < fields.length; index += 1) {
      var stamp = Date.parse(outfit && outfit[fields[index]] || '');
      if (isFinite(stamp)) return stamp;
    }
    return Number(outfit && outfit.id || 0) || 0;
  }

  function itemImage(item) {
    if (!item) return '';
    return safeImageUrl(item.featuredImage && item.featuredImage.url || item.imageUrl || item.image);
  }

  function itemOrientationHint(item) {
    var attributes = item && item.attributes || {};
    var shape = [
      item && item.category,
      item && item.productType,
      item && item.title,
      attributes.type,
      attributes.style
    ].join(' ').toLowerCase();
    return /\b(jeans?|trousers?|pants?|leggings?|jeggings?|dungarees?|overalls?|jumpsuits?|dresses?|skirts?|coats?|jackets?|blazers?|parkas?|macs?|trenches?|gilets?|waistcoats?|cardigans?|hoodies?|hooded|sweatshirts?|jumpers?|pullovers?|sweaters?)\b/.test(shape)
      ? 'portrait' : 'landscape';
  }

  function itemImageAttributes(item) {
    var image = item && item.featuredImage || {};
    var width = Math.max(0, Math.round(Number(image.width) || 0));
    var height = Math.max(0, Math.round(Number(image.height) || 0));
    return (width ? ' data-image-width="' + width + '"' : '') +
      (height ? ' data-image-height="' + height + '"' : '') +
      ' data-garment-orientation="' + itemOrientationHint(item) + '"';
  }

  function productImageMarkup(item, label) {
    var image = itemImage(item);
    if (!image) return '';
    return '<span class="pwhome-outfits__product-image" role="img" aria-label="' + escapeHtml(label || itemLabel(item)) + '"' +
      ' data-pwhome-outfit-image data-image-src="' + escapeHtml(image) + '"' + itemImageAttributes(item) + '></span>';
  }

  function itemLabel(item) {
    return cleanName(item && (item.category || item.productType || item.vendor), 'Piece');
  }

  function outfitLink(root, outfit, editMode) {
    var base = root.getAttribute('data-pwhome-outfits-builder') || '/pages/build-an-outfit';
    try {
      var url = new URL(base, window.location.origin);
      url.searchParams.set('edit_outfit', String(outfit.id));
      url.hash = editMode || !safeImageUrl(outfit.previewImageUrl) ? 'BuildAnOutfit' : 'ai-look-preview';
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return '/pages/build-an-outfit?edit_outfit=' + encodeURIComponent(outfit.id) + '#BuildAnOutfit';
    }
  }

  function collageMarkup(items) {
    var images = (Array.isArray(items) ? items : []).map(function (item) {
      return { url: itemImage(item), label: itemLabel(item), attributes: itemImageAttributes(item) };
    }).filter(function (image) { return !!image.url; }).slice(0, 4);
    if (!images.length) return '<span class="pwhome-outfits__placeholder"><b>PREWORN</b><small>YOUR OUTFIT</small></span>';
    return '<span class="pwhome-outfits__collage pwhome-outfits__collage--' + images.length + '">' + images.map(function (image) {
      return '<span><span class="pwhome-outfits__product-image" role="img" aria-label="' + escapeHtml(image.label) + '"' +
        ' data-pwhome-outfit-image data-image-src="' + escapeHtml(image.url) + '"' + image.attributes + '></span></span>';
    }).join('') + '</span>';
  }

  function productSummary(items) {
    var labels = [];
    (Array.isArray(items) ? items : []).forEach(function (item) {
      var value = itemLabel(item).toUpperCase();
      if (value && labels.indexOf(value) === -1) labels.push(value);
    });
    return labels.slice(0, 3).join(' · ') || 'COMPLETE LOOK';
  }

  function productHref(item) {
    var supplied = String(item && item.onlineStoreUrl || '').trim();
    if (supplied) {
      try {
        var url = new URL(supplied, window.location.origin);
        if (url.origin === window.location.origin || url.protocol === 'https:') return url.href;
      } catch (error) {}
    }
    return item && item.handle ? '/products/' + encodeURIComponent(item.handle) : '#';
  }

  function shortProductTitle(item) {
    var title = cleanName(item && item.title, itemLabel(item));
    var vendor = cleanName(item && item.vendor, '');
    if (vendor) title = title.replace(new RegExp('^' + vendor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*[-–—:]?\\s*', 'i'), '');
    return title.split(/\s+/).slice(0, 4).join(' ') || itemLabel(item);
  }

  function tierPrice(rawPrice) {
    var original = Math.max(0, Number(rawPrice) || 0);
    var multiplier = .45;
    if (!original) return { original: 0, current: 0 };
    if (original <= 5) multiplier = .9;
    else if (original <= 10) multiplier = .8;
    else if (original <= 15) multiplier = .7;
    else if (original <= 20) multiplier = .6;
    else if (original < 30) multiplier = .55;
    return { original: original, current: Math.round(original * multiplier * 100) / 100 };
  }

  function outfitTotals(items) {
    var prices = [];
    (Array.isArray(items) ? items : []).forEach(function (item, index) {
      if (item && item.availableForSale === false) return;
      var amount = item && item.priceRange && item.priceRange.minVariantPrice
        ? item.priceRange.minVariantPrice.amount : 0;
      var price = tierPrice(amount);
      if (!price.original) return;
      price.slotId = String(item && item.position != null ? item.position : index);
      prices.push(price);
    });
    var freeCount = Math.floor(prices.length / 3);
    var free = {};
    var offer = 0;
    prices.slice().sort(function (left, right) { return left.current - right.current; }).slice(0, freeCount).forEach(function (price) {
      free[price.slotId] = true;
      offer += price.current;
    });
    var prp = prices.reduce(function (sum, price) { return sum + price.original; }, 0);
    var standard = prices.reduce(function (sum, price) { return sum + price.current; }, 0);
    return {
      total: Math.max(0, Math.round((standard - offer) * 100) / 100),
      saving: Math.max(0, Math.round((prp - standard + offer) * 100) / 100),
      freeCount: freeCount,
      freeSlotIds: free
    };
  }

  function currencyCode(items) {
    var item = (Array.isArray(items) ? items : []).filter(function (candidate) {
      return candidate && candidate.priceRange && candidate.priceRange.minVariantPrice;
    })[0];
    return item ? item.priceRange.minVariantPrice.currencyCode || 'GBP' : 'GBP';
  }

  function money(amount, currency) {
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency', currency: currency || 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(Number(amount) || 0);
    } catch (error) {
      return '£' + (Number(amount) || 0).toFixed(2);
    }
  }

  function displayOutfitTitle(outfit, wardrobeName) {
    var title = cleanName(outfit && outfit.name, '');
    if (!title || /\bwardrobe\s+outfit\b|\boutfit\s*[·|:-]|\bai\s+look\b/i.test(title)) {
      return wardrobeName + (/[sxz]$/i.test(wardrobeName) ? '’' : '’s') + ' Styled Edit';
    }
    return title;
  }

  function iconMarkup(name) {
    var paths = {
      person: '<circle cx="12" cy="7" r="3"></circle><path d="M5.5 20c.6-4.2 2.8-6.4 6.5-6.4s5.9 2.2 6.5 6.4"></path>',
      hanger: '<path d="M9 6a3 3 0 1 1 4.5 2.6L20 14v3H4v-3l8-6"></path>',
      list: '<path d="M9 6h11M9 12h11M9 18h11"></path><circle cx="4" cy="6" r="1"></circle><circle cx="4" cy="12" r="1"></circle><circle cx="4" cy="18" r="1"></circle>',
      layers: '<path d="m4 8 8-4 8 4-8 4-8-4Z"></path><path d="m5 12 7 4 7-4M6 16l6 4 6-4"></path>',
      gift: '<path d="M4 10h16v10H4V10ZM3 7h18v3H3V7ZM12 7v13"></path><path d="M12 7H8.5a2 2 0 1 1 2-2c0 1.2 1.5 2 1.5 2Zm0 0h3.5a2 2 0 1 0-2-2c0 1.2-1.5 2-1.5 2Z"></path>',
      tag: '<path d="M4 5h9l7 7-8 8-8-8V5Z"></path><circle cx="9" cy="9" r="1"></circle>',
      palette: '<path d="M12 3a9 9 0 1 0 0 18h1.5a2 2 0 0 0 0-4H12a2 2 0 0 1 0-4h2a7 7 0 0 0-2-10Z"></path><circle cx="8" cy="9" r=".7"></circle><circle cx="12" cy="7" r=".7"></circle><circle cx="16" cy="9" r=".7"></circle>',
      coins: '<ellipse cx="12" cy="6" rx="7" ry="3"></ellipse><path d="M5 6v4c0 1.7 3.1 3 7 3s7-1.3 7-3V6M5 10v4c0 1.7 3.1 3 7 3s7-1.3 7-3v-4M5 14v4c0 1.7 3.1 3 7 3s7-1.3 7-3v-4"></path>'
    };
    return '<svg aria-hidden="true" viewBox="0 0 24 24">' + (paths[name] || paths.layers) + '</svg>';
  }

  function productCardMarkup(item, index, totals, currency) {
    var image = itemImage(item);
    var slotId = String(item && item.position != null ? item.position : index);
    var isFree = item && item.availableForSale !== false && !!totals.freeSlotIds[slotId];
    var sold = item && item.availableForSale === false;
    var amount = item && item.priceRange && item.priceRange.minVariantPrice
      ? item.priceRange.minVariantPrice.amount : 0;
    var price = tierPrice(amount);
    var title = shortProductTitle(item);
    return '<a class="pwhome-outfits__item' + (sold ? ' is-sold' : '') + '" href="' + escapeHtml(productHref(item)) + '" aria-label="View ' + escapeHtml(title) + '">' +
      '<span>' + (image ? productImageMarkup(item, title) : '<b>PREWORN</b>') +
        (isFree ? '<em>FREE</em>' : sold ? '<em class="is-sold">SOLD</em>' : '') +
      '</span>' +
      '<small>' + escapeHtml(cleanName(item && item.vendor, itemLabel(item))) + '</small>' +
      '<strong>' + escapeHtml(title) + '</strong>' +
      '<b>' + (sold ? 'Unavailable' : isFree ? money(0, currency) : money(price.current, currency)) + '</b>' +
    '</a>';
  }

  function specificValue(value) {
    return String(value || '')
      .replace(/^(?:material|pattern|condition|style|feature|features|type)[_:\s-]+/i, '')
      .replace(/\s*\|\s*/g, ', ')
      .replace(/_+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function productSpecifics(item) {
    var attributes = item && item.attributes || {};
    var size = specificValue(attributes.size);
    if (/^(?:xs|s|m|l|xl|xxl|xxxl)$/i.test(size)) size = size.toUpperCase();
    var catalogueSpecifics = item && Array.isArray(item.specifics) ? item.specifics : [];
    var source = catalogueSpecifics.length ? catalogueSpecifics.map(function (specific) {
      return [specific && specific.label, specific && specific.value];
    }) : [
      ['Brand', item && item.vendor],
      ['Size', size],
      ['Condition', attributes.condition],
      ['Material', attributes.material],
      ['Colour', attributes.colour || attributes.color],
      ['Department', attributes.department || item && item.department],
      ['Features', attributes.features],
      ['Pattern', attributes.pattern],
      ['Style', attributes.style],
      ['Type', attributes.type || itemLabel(item)]
    ];
    var seen = {};
    return source.map(function (specific) {
      return { label: specific[0], value: specificValue(specific[1]) };
    }).filter(function (specific) {
      var key = String(specific.label || '').toLowerCase();
      if (!key || !specific.value || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function productSpecificsMarkup(item) {
    return '<dl class="pwhome-outfits__item-specifics" aria-label="Item specifics for ' + escapeHtml(shortProductTitle(item)) + '">' +
      productSpecifics(item).map(function (specific) {
        return '<div><dt>' + escapeHtml(specific.label) + '</dt><dd>' + escapeHtml(specific.value) + '</dd></div>';
      }).join('') + '</dl>';
  }

  function flatPanelMarkup(items) {
    return '<section class="pwhome-outfits__flat-panel pwhome-outfits__view-panel" data-pwhome-outfit-panel="flat" role="tabpanel" hidden>' +
      '<div aria-label="Flat images of every item in this outfit">' + (Array.isArray(items) ? items : []).slice(0, 4).map(function (item) {
        var image = itemImage(item);
        return '<figure>' + (image
          ? productImageMarkup(item, shortProductTitle(item))
          : '<b>PREWORN</b>') + '</figure>';
      }).join('') + '</div>' +
    '</section>';
  }

  function detailsPanelMarkup(items, totals, currency) {
    return '<section class="pwhome-outfits__details-panel pwhome-outfits__view-panel" data-pwhome-outfit-panel="details" role="tabpanel" hidden>' +
      '<div class="pwhome-outfits__details-items">' + (Array.isArray(items) ? items : []).slice(0, 4).map(function (item, index) {
        var image = itemImage(item);
        var slotId = String(item && item.position != null ? item.position : index);
        var free = item && item.availableForSale !== false && !!totals.freeSlotIds[slotId];
        var sold = item && item.availableForSale === false;
        var amount = item && item.priceRange && item.priceRange.minVariantPrice
          ? item.priceRange.minVariantPrice.amount : 0;
        var currentPrice = tierPrice(amount).current;
        return '<article>' +
          '<div class="pwhome-outfits__details-summary"><span class="pwhome-outfits__details-image">' + (image
            ? productImageMarkup(item, shortProductTitle(item))
            : '<b>PREWORN</b>') + '</span>' +
          '<div><small>' + escapeHtml(itemLabel(item)) + '</small><strong>' + escapeHtml(cleanName(item && item.vendor, 'PREWORN')) + ' · ' + escapeHtml(shortProductTitle(item)) + '</strong></div>' +
          '<b class="pwhome-outfits__details-price">' + (sold ? 'SOLD' : free ? 'FREE' : money(currentPrice, currency)) + '</b></div>' +
          productSpecificsMarkup(item) + '</article>';
      }).join('') + '</div>' +
    '</section>';
  }

  function cardMarkup(root, outfit, wardrobe) {
    var items = Array.isArray(outfit.items) ? outfit.items : [];
    var preview = safeImageUrl(outfit.previewImageUrl);
    var href = outfitLink(root, outfit);
    var editHref = outfitLink(root, outfit, true);
    var wardrobeName = cleanName(wardrobe.name, 'My Wardrobe');
    var title = displayOutfitTitle(outfit, wardrobeName);
    var totals = outfitTotals(items);
    var currency = currencyCode(items);
    var media = preview
      ? '<img class="pwhome-outfits__preview" src="' + escapeHtml(preview) + '" alt="Preview of ' + escapeHtml(title) + '" loading="lazy" data-pwhome-outfit-image>'
      : collageMarkup(items);
    return '<article class="pwhome-outfits__card">' +
      '<section class="pwhome-outfits__media pwhome-outfits__view-panel' + (preview ? ' has-preview' : ' has-flat') + '" data-pwhome-outfit-panel="preview" role="tabpanel">' +
        '<a class="pwhome-outfits__hero-link" href="' + escapeHtml(href) + '" aria-label="Open ' + escapeHtml(title) + '">' + media + '</a>' +
        '<div class="pwhome-outfits__hero-copy">' +
          '<small>STYLED ON YOU</small><h3>' + escapeHtml(title) + '</h3>' +
          '<p>Built from your ' + escapeHtml(wardrobeName) + ' wardrobe preferences.</p>' +
          '<div><span>' + iconMarkup('layers') + items.length + ' PIECE' + (items.length === 1 ? '' : 'S') + '</span>' +
          (totals.freeCount ? '<b>' + iconMarkup('gift') + totals.freeCount + ' FREE</b>' : '') + '</div>' +
        '</div>' +
      '</section>' +
      flatPanelMarkup(items) +
      detailsPanelMarkup(items, totals, currency) +
      '<section class="pwhome-outfits__sheet">' +
        '<div class="pwhome-outfits__views" role="tablist" aria-label="Available outfit views">' +
          '<button type="button" role="tab" class="is-active" data-pwhome-outfit-view="preview" aria-selected="true">' + iconMarkup('person') + 'Preview on you</button>' +
          '<button type="button" role="tab" data-pwhome-outfit-view="flat" aria-selected="false">' + iconMarkup('hanger') + 'Flat items</button>' +
          '<button type="button" role="tab" data-pwhome-outfit-view="details" aria-selected="false">' + iconMarkup('list') + 'Details</button>' +
        '</div>' +
        '<div class="pwhome-outfits__items" aria-label="Items in this outfit">' + items.slice(0, 4).map(function (item, index) {
          return productCardMarkup(item, index, totals, currency);
        }).join('') + '</div>' +
        '<div class="pwhome-outfits__purchase">' +
          '<div><small>LIVE OUTFIT PRICE</small><strong>' + money(totals.total, currency) + '</strong>' +
            (totals.saving ? '<span>Save ' + money(totals.saving, currency) + ' ↗</span>' : '') + '</div>' +
          '<a class="pwhome-outfits__swap" href="' + escapeHtml(editHref) + '">' + iconMarkup('hanger') + 'SWAP ITEMS</a>' +
          '<a class="pwhome-outfits__open" href="' + escapeHtml(href) + '">OPEN OUTFIT <b aria-hidden="true">→</b></a>' +
        '</div>' +
        '<footer class="pwhome-outfits__why"><div><h4>Why this works for you</h4><a href="' + escapeHtml(editHref) + '">See details <span aria-hidden="true">›</span></a></div>' +
          '<p><span>' + iconMarkup('hanger') + '<b>Matches your<br>saved sizes</b></span>' +
          '<span>' + iconMarkup('tag') + '<b>Includes your<br>preferred brands</b></span>' +
          '<span>' + iconMarkup('palette') + '<b>Uses your<br>chosen colours</b></span>' +
          '<span>' + iconMarkup('coins') + '<b>Shows the live<br>outfit price</b></span></p>' +
        '</footer>' +
      '</section>' +
    '</article>';
  }

  function classifyImage(image, resolvedWidth, resolvedHeight) {
    if (!image) return;
    var width = Number(resolvedWidth) || Number(image.getAttribute('data-image-width')) || Number(image.naturalWidth) || 0;
    var height = Number(resolvedHeight) || Number(image.getAttribute('data-image-height')) || Number(image.naturalHeight) || 0;
    var garmentOrientation = image.getAttribute('data-garment-orientation');

    /* A catalogue canvas can be square or wide even when the garment itself
       is vertical. Never let that canvas ratio turn coats, cardigans, jeans or
       trousers into a cover crop. A genuinely portrait source is also always
       shown complete. */
    var portrait = garmentOrientation === 'portrait' || (!!width && !!height && height > width);
    if (!width && !height && !garmentOrientation) return;
    image.classList.toggle('is-portrait', portrait);
    image.classList.toggle('is-landscape', !portrait);
    image.setAttribute('data-image-orientation', portrait ? 'portrait' : 'landscape');

    if (image.classList.contains('pwhome-outfits__product-image')) {
      image.style.setProperty('background-size', portrait ? 'auto 100%' : 'cover', 'important');
      return;
    }

      var heroPreview = image.classList.contains('pwhome-outfits__preview');
      image.style.setProperty('object-fit', heroPreview || !portrait ? 'cover' : 'contain', 'important');
  }

  function classifyImages(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-pwhome-outfit-image]').forEach(function (image) {
      var source = image.getAttribute('data-image-src');
      if (source) {
        image.style.backgroundImage = 'url(' + JSON.stringify(source) + ')';
        classifyImage(image);
        if (image.getAttribute('data-image-probed') === 'true') return;
        image.setAttribute('data-image-probed', 'true');
        var probe = new Image();
        probe.onload = function () { classifyImage(image, probe.naturalWidth, probe.naturalHeight); };
        probe.src = source;
      } else if (image.complete) classifyImage(image);
      else image.addEventListener('load', function () { classifyImage(image); }, { once: true });
    });
  }

  function switchCardView(button) {
    var card = button && button.closest('.pwhome-outfits__card');
    if (!card) return;
    var view = button.getAttribute('data-pwhome-outfit-view') || 'preview';
    card.querySelectorAll('[data-pwhome-outfit-view]').forEach(function (candidate) {
      var active = candidate.getAttribute('data-pwhome-outfit-view') === view;
      candidate.classList.toggle('is-active', active);
      candidate.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    card.querySelectorAll('[data-pwhome-outfit-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-pwhome-outfit-panel') !== view;
    });
    classifyImages(card);
  }

  function setWardrobeCopy(root, wardrobe) {
    var name = cleanName(wardrobe && wardrobe.name, 'My Wardrobe');
    root.querySelectorAll('[data-pwhome-outfits-wardrobe]').forEach(function (node) { node.textContent = name.toUpperCase(); });
    root.querySelectorAll('[data-pwhome-outfits-empty-name]').forEach(function (node) { node.textContent = name; });
    var viewAll = root.querySelector('[data-pwhome-outfits-view-all]');
    if (viewAll) {
      var base = root.getAttribute('data-pwhome-outfits-index') || '/pages/my-outfits';
      viewAll.href = base + '?wardrobe=' + encodeURIComponent(wardrobe.id);
    }
    var build = root.querySelector('[data-pwhome-outfits-build]');
    if (build) {
      var builder = root.getAttribute('data-pwhome-outfits-builder') || '/pages/build-an-outfit';
      build.href = builder + '?wardrobe=' + encodeURIComponent(wardrobe.id) + '#BuildAnOutfit';
    }
  }

  function renderLoading(root, wardrobe) {
    setWardrobeCopy(root, wardrobe);
    root.hidden = false;
    var grid = root.querySelector('[data-pwhome-outfits-grid]');
    var empty = root.querySelector('[data-pwhome-outfits-empty]');
    var status = root.querySelector('[data-pwhome-outfits-status]');
    var count = root.querySelector('[data-pwhome-outfits-count]');
    if (status) status.textContent = 'Loading the looks saved to this wardrobe…';
    if (count) count.hidden = true;
    if (empty) empty.hidden = true;
    if (grid) {
      grid.hidden = false;
      grid.setAttribute('aria-busy', 'true');
      grid.innerHTML = '<span class="pwhome-outfits__skeleton"></span><span class="pwhome-outfits__skeleton"></span><span class="pwhome-outfits__skeleton"></span>';
    }
  }

  function renderOutfits(root, wardrobe, outfits) {
    var grid = root.querySelector('[data-pwhome-outfits-grid]');
    var empty = root.querySelector('[data-pwhome-outfits-empty]');
    var status = root.querySelector('[data-pwhome-outfits-status]');
    var count = root.querySelector('[data-pwhome-outfits-count]');
    var matching = (Array.isArray(outfits) ? outfits : []).filter(function (outfit) {
      return String(outfit && (outfit.wardrobeId || outfit.wardrobe_id) || '') === String(wardrobe.id);
    }).sort(function (left, right) { return outfitTimestamp(right) - outfitTimestamp(left); });
    if (status) status.textContent = matching.length
      ? 'Complete looks built from the wardrobe you have active.'
      : 'Build a complete look from this wardrobe and it will appear here.';
    if (count) {
      count.textContent = matching.length + ' SAVED LOOK' + (matching.length === 1 ? '' : 'S');
      count.hidden = false;
    }
    if (grid) {
      grid.innerHTML = matching.slice(0, MAX_OUTFITS).map(function (outfit) {
        return cardMarkup(root, outfit, wardrobe);
      }).join('');
      classifyImages(grid);
      grid.hidden = !matching.length;
      grid.setAttribute('aria-busy', 'false');
    }
    if (empty) empty.hidden = !!matching.length;
    root.hidden = false;
  }

  function renderError(root, wardrobe) {
    var grid = root.querySelector('[data-pwhome-outfits-grid]');
    var empty = root.querySelector('[data-pwhome-outfits-empty]');
    var status = root.querySelector('[data-pwhome-outfits-status]');
    var count = root.querySelector('[data-pwhome-outfits-count]');
    if (grid) { grid.hidden = true; grid.setAttribute('aria-busy', 'false'); grid.innerHTML = ''; }
    if (empty) empty.hidden = false;
    if (count) count.hidden = true;
    if (status) status.textContent = 'Your saved looks are temporarily unavailable.';
    setWardrobeCopy(root, wardrobe);
    root.hidden = false;
  }

  function refresh(root) {
    var generation = ++requestGeneration;
    var wardrobe = activeWardrobe();
    var loggedIn = root.getAttribute('data-pwhome-outfits-customer') === 'true';
    if (!loggedIn || !wardrobe) {
      root.hidden = true;
      return Promise.resolve();
    }
    renderLoading(root, wardrobe);
    return window.fetch(root.getAttribute('data-pwhome-outfits-api') || '/apps/preworn/wardrobes/outfits', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok || body.error) throw new Error(body.error || 'outfits_unavailable');
        return body;
      });
    }).then(function (body) {
      if (generation !== requestGeneration) return;
      var current = activeWardrobe();
      if (!current || String(current.id) !== String(wardrobe.id)) return refresh(root);
      renderOutfits(root, wardrobe, body.outfits);
    }).catch(function () {
      if (generation === requestGeneration && activeWardrobe()) renderError(root, wardrobe);
    });
  }

  function init() {
    var root = document.querySelector('[data-pwhome-active-outfits]');
    if (!root || root.getAttribute('data-pwhome-outfits-bound') === 'true') return;
    root.setAttribute('data-pwhome-outfits-bound', 'true');
    root.addEventListener('click', function (event) {
      var view = event.target.closest('[data-pwhome-outfit-view]');
      if (!view || !root.contains(view)) return;
      event.preventDefault();
      switchCardView(view);
    });
    var start = function () { refresh(root); };
    if (window.PrewornWardrobe && typeof window.PrewornWardrobe.ready === 'function') {
      Promise.resolve(window.PrewornWardrobe.ready()).then(start).catch(start);
    } else {
      start();
    }
    window.addEventListener('preworn:wardrobe-change', start);
    window.addEventListener('preworn:outfits-change', start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
